import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

import { IS_TENANT } from 'tenant/config';
import ShipperOrderCell from './component';

const fields = ['shipper_orders', 'shipper_orders_skin', 'status', 'stops'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const {
      shipper_orders: shipperOrders,
      shipper_orders_skin: shipperOrdersSkin,
      stops,
    } = props.selectors.getJourneyFields(state, props.journeyId, fields);

    const shipperOrder = shipperOrders.find(({ id }) => id === props.shipperOrderId);
    const {
      shipper,
      status,
      insured_for: insuredFor,
      is_high_priority: isHighPriority,
      recurring_order: isRecurring,
    } = shipperOrder;
    const { isNew, isPriority } = shipper;

    const shipperOrderSkin = shipperOrdersSkin[shipperOrder.id];

    const isExport = IS_TENANT
      ? {
          is_export:
            stops.length > 2 && stops[0].stop_type === 'PICKUP' && stops[1].stop_type === 'PICKUP',
        }
      : {};

    return {
      shipperCompanyName: shipper.company_name,
      isHighPriority,
      isNew,
      isPriority,
      isRecurring: isRecurring === true || isRecurring === 'true',
      isInsured: insuredFor > 0,
      shipperOrderSkin,
      ...isExport,
      isCancelled: status === 'CANCELLED',
    };
  }),
  withProps(({ shipperOrderSkin, numberOfShipperOrders }) => ({
    isGroupage: numberOfShipperOrders > 1,
    skin: shipperOrderSkin,
  })),
  withHandlers({
    onRemoveClick:
      ({ shipperOrderId, onRemoveClick }) =>
      () => {
        onRemoveClick(shipperOrderId);
      },
  })
);

export default enhance(ShipperOrderCell);
